import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store/store'
import vuetify from '@/plugins/vuetify'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import AuthImage from './helpers/AuthImage'
import VuetifyDialogPromise from 'vuetify-dialog-promise'
import VueResize from 'vue-resize'
import 'vue-resize/dist/vue-resize.css'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)
Vue.use(VueResize)

/**
 * Autmatic base component registering
 */
const requireComponent = require.context(
  './components',
  false,
  /Base[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)

  const componentName = upperFirst(
    camelCase(fileName.replace(/^\.\/(.*)\.\w+$/, '$1'))
  )

  console.log('PROCCESS ENV: ', process.env)

  Vue.component(componentName, componentConfig.default || componentConfig)

  Vue.directive('auth-image', {
    bind: function(el, binding) {
      AuthImage.setImgSrc(el, binding)
    },
    componentUpdated: function(el, binding) {
      AuthImage.setImgSrc(el, binding)
    }
  })
})

Vue.use(VuetifyDialogPromise, {
  locale: 'en',
  snackbarX: 'left',
  snackbarY: 'bottom',
  theme: { dark: true }
})

/**
 * END - Autmatic base component registering
 */

// router.beforeEach((to, from, next) => {
//   if (to.name && to.name==='logout') {
//     store.dispatch('logout')
//   } else {
//     next()
//   }
//
// })

// set up i18n
import { languages } from './locales/index.js'
import { defaultLocale } from './locales/index.js'
const messages = Object.assign(languages)

Vue.config.productionTip = false

var i18n = new VueI18n({
  locale: defaultLocale,
  fallbackLocale: 'en',
  messages
})
// end set up i18n
const moment = require('vue-moment')
Vue.use(moment)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
  created: function() {
    if (localStorage.apiCredentials) {
      store.dispatch('AuthStore/refreshUserProfile')
    }
  }
}).$mount('#app')
